import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { PartType, PartTypeQueryParams } from "../types";

interface PartTypeState {
  partTypes: Array<PartType>;
  partTypesTotal: number;
  partType?: PartType;
}

const initialState: PartTypeState = {
	partTypes: [],
	partTypesTotal: 0,
};

export const partTypeSlice = createSlice({
	name: "partType",
	initialState,
	reducers: {
		setPartTypes: (state, action) => {
			state.partTypes = action.payload.data;
			state.partTypesTotal = action.payload.total;
		},
		setPartType: (state, action) => {
			state.partType = action.payload.data;
		},
		changeStatusPartType: (state, action) => {
			const { id, status } = action.payload;
			const index = state.partTypes.findIndex(el => el._id === id);
			state.partTypes[index].status = status;
		},
	},
});

export const selectPartTypes = (state: RootState) => state.partType.partTypes;
export const selectPartTypesTotal = (state: RootState) => state.partType.partTypesTotal;
export const selectPartType = (state: RootState) => state.partType.partType;

export const { setPartTypes, setPartType, changeStatusPartType } = partTypeSlice.actions;

export interface GetPartTypesAsyncPayload {
  query: PartTypeQueryParams;
	callback?: () => void;
}
export interface GetPartTypeDetailsPayload {
  id: string;
	callback?: (partType?: PartType) => void;
}
export interface CreatePartTypePayload {
  data: PartType;
  callback: () => void;
}
export interface UpdatePartTypePayload {
  id: string;
  data: PartType;
	callback?: () => void;
}

export interface UpdatePartTypeStatusPayload {
  id: string;
  status: string;
	callback?: () => void;
}

export const getPartTypesAsync = createAction(
	"partType/getPartTypes",
	(payload: GetPartTypesAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getPartTypeDetailsAsync = createAction(
	"partType/getPartTypeDetails",
	(payload: GetPartTypeDetailsPayload) => ({
		payload: payload,
	})
);

export const createNewPartTypeAsync = createAction(
	"partType/createNewPartType",
	(payload: CreatePartTypePayload) => ({
		payload: payload,
	})
);

export const updatePartTypeAsync = createAction(
	"partType/updatePartType",
	(payload: UpdatePartTypePayload) => ({
		payload: payload,
	})
);


export const updatePartTypeStatusAsync = createAction(
	"partType/updatePartTypeStatusAsync",
	(payload: UpdatePartTypeStatusPayload) => ({
		payload: payload,
	})
);

export default partTypeSlice.reducer;
